import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Define the initial state of the orders slice
const initialState = {
  orders: [],
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  mediaData: {},
  error: null,
  totalPages: 0,
  currentPage: 1,
  tabChange: "",
};

// Async thunk to fetch orders
export const fetchOrders = createAsyncThunk(
  "orders/fetchOrders",
  async (page, { dispatch }) => {
    const token = localStorage.getItem("token"); // Retrieve the token from localStorage
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/user/orders`,
      {
        headers: {
          Authorization: token,
        },
        params: { page: page ? page : 1, limit: 10 },
      }
    );
    dispatch(pagesCount(response.data?.totalPages));
    return response.data.orders; // Returning only the orders array
  }
);

// Async thunk to cancel an order
export const cancelOrder = createAsyncThunk(
  "orders/cancelOrder",
  async (orderId) => {
    const token = localStorage.getItem("token"); // Retrieve the token from localStorage
    const response = await axios.delete(
      `${process.env.REACT_APP_API_URL}/orders/${orderId}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );

    if (response.data.error === false) {
      return orderId; // Return the orderId to remove the canceled order from the list
    } else {
      throw new Error("Failed to cancel the order.");
    }
  }
);

export const fetchMediaData = createAsyncThunk(
  "orders/fetchMediaData",
  async (orders) => {
    const mediaPromises = orders.flatMap((order) =>
      order.products.map((product) =>
        axios.get(
          `${process.env.REACT_APP_API_URL}/getmedia/${product.media_id}`
        )
      )
    );

    const mediaResponses = await Promise.all(mediaPromises);
    const mediaData = {};
    mediaResponses.forEach((response, index) => {
      const mediaId = orders.flatMap((order) => order.products)[index].media_id;
      mediaData[mediaId] = response.data;
    });

    return mediaData;
  }
);

const ordersSlice = createSlice({
  name: "orders",
  mediaData: {}, // New field to store media data
  initialState,
  reducers: {
    pagesCount: (state, action) => {
      state.totalPages = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },

    changeRouter: (state, action) => {
      state.tabChange = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.orders = action.payload; // Update the orders array
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        // state.currentPage=1;
        // state.totalPages=0
      })
      .addCase(cancelOrder.pending, (state) => {
        state.status = "loading"; // Optional: Show loading state for cancel action
      })
      .addCase(cancelOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        // Remove the canceled order from the state
        state.orders = state.orders.filter(
          (order) => order._id !== action.payload
        );
      })
      .addCase(cancelOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;

      })
      .addCase(fetchMediaData.pending, (state) => {
        state.mediaStatus = "loading";
      })
      .addCase(fetchMediaData.fulfilled, (state, action) => {
        state.mediaStatus = "succeeded";
        state.mediaData = action.payload; // Store media data
      })
      .addCase(fetchMediaData.rejected, (state, action) => {
        state.mediaStatus = "failed";
        state.error = action.error.message;
      });
  },
});
export const { pagesCount, setCurrentPage, changeRouter } = ordersSlice.actions;
export default ordersSlice.reducer;
